export const retiredWorkspaceFeatureIds = ["facility-findings","psm-findings","safety-kpi","improvement-request","task-risk","contractor-compliance","contractor-compliance-review","partner-daily-inspection","standards-templates","asset-safety-management","rigging-qualification","monthly-calendar","daily-closeout","notices-alerts","safety-violation","safety-suggestion","material-request","monthly-report","hq-documents","statutory-records","finding-action"] as const;
const unmountedFeatureIds = new Set<string>(['worker-roster', ...retiredWorkspaceFeatureIds]);

const unmountedPaths: Readonly<Record<string, string>> = {
  '/work-permit': '/work',
  '/work-plan': '/work',
  '/admin/worker-roster': '/',
  '/admin/board-categories': '/',
  '/admin/migration-review': '/',
  '/documents/manuals': '/documents',
  '/documents/swp': '/documents',
  '/shared-resources': '/documents',
  '/organisation': '/documents',
  '/site-map': '/documents',
  '/safety-design': '/documents',
};

const retiredDocumentPrefixes = ['/documents/manuals/', '/documents/swp/', '/shared-resources/'];

/** Product-shell policy only. Registration links and the preserved roster implementation are separate. */
export function workspaceFeatureMounted(featureId: string) {
  return !unmountedFeatureIds.has(featureId);
}

/** Retired management deep links fail closed to the authenticated workspace home. */
export function normalizeWorkspacePath(pathname: string) {
  const retired = ['/inspections/facility', '/inspections/psm', '/inspections/findings', '/risk-assessment/ad-hoc', '/materials', '/reports/monthly', '/reports/half-year', '/contractor-compliance', '/documents/daily', '/records/statutory', '/assets/safety', '/assets/chemicals', '/assets/equipment', '/credentials/rigging', '/communications/calendar', '/communications/notices', '/communications/suggestions', '/communications/violations', '/communications/closeout', '/feedback', '/admin/feedback'];
  if (retired.some((path) => pathname === path || pathname.startsWith(path + '/'))) return '/';
  if (retiredDocumentPrefixes.some((prefix) => pathname.startsWith(prefix))) return '/documents';
  return unmountedPaths[pathname] ?? pathname;
}
